import React, { useEffect, useState, useRef } from "react";

// import Button from '@material-ui/core/Button';
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  Card,
  Button,
  CardFooter,
  CardBody,
  FormGroup,
  Input,
  Container,
  Col,
  Form,
  FormFeedback,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";

const ResetOTP = ({ handleOTPSuccess }) => {
  let errMessage = "Enter OTP";
  let currentInputIndex = useRef(0);
  const maxInputSize = 1;
  const [seconds, setSeconds] = useState(30);
  const [displayResend, setDisplayResend] = useState(false);
  // let mobile = useSelector(mobileNumber);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [err, setErr] = useState(false);
  const inputRefs = useRef([]);
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;
    setOtp([...otp.map((data, idx) => (idx === index ? element.value : data))]);
    const nextInput = element.nextSibling;
    if (!(element.value === "") && nextInput) {
      element.nextSibling.focus();
      currentInputIndex.current = index + 1;
    }
  };
  const handleClear = () => {
    setOtp(new Array(6).fill(""));
  };
  // const handleResendOTP =async () =>{
  //     const payload ={
  //       mobile
  //     }
  //     try {
  //       await resendOTP(payload).then((res) => {
  //         console.log({ res });
  //         if (
  //           (res?.status === 200 && res.data?.statusCode === "200") ||
  //           (res?.status === 201 && res.data?.statusCode === " 201")
  //         ) {
  //           dispatch(showNotification(res?.data?.message, notificationType?.SUCCESS));

  //         } else {
  //           dispatch(showNotification(res?.data?.message, notificationType?.ERROR));

  //         }
  //       });
  //     } catch (err) {
  //       console.log({ err });
  //       dispatch(
  //         showNotification(
  //           err?.data?.message || "Something went wrong. Try again !",
  //           notificationType?.ERROR
  //         )
  //       );

  //     }
  //   }
  const handleOTPVerification = () => {
    if (otp.includes("")) {
      setErr(true);
      return;
    }
    let otpString = otp.join("");
    handleOTPSuccess(otpString);
  };
  useEffect(() => {
    inputRefs.current[currentInputIndex.current].focus();

    const handleKeyDown = (event) => {
      if (event.keyCode === 37) {
        currentInputIndex.current = Math.max(currentInputIndex.current - 1, 0);
        inputRefs.current[currentInputIndex.current].focus();
      } else if (event.keyCode === 39) {
        currentInputIndex.current++;
        inputRefs.current[currentInputIndex.current].focus();
      } else if (event.keyCode === 8) {
        const currentInput = inputRefs.current[currentInputIndex.current];
        if (currentInput.value === "" && currentInputIndex.current > 0) {
          currentInputIndex.current--;
          inputRefs.current[currentInputIndex.current].focus();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    setErr(false);
  }, [otp]);
  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds - 1);
    }, 1000);

    if (seconds === 0) {
      setDisplayResend(true);
      clearInterval(timer);
    }

    return () => clearInterval(timer);
  }, [seconds]);

  return (
    <div>
     
        <Box
          mb={3}
          sx={{
            display: "flex",
            width: "100%",
            columnGap: 2,
            justifyContent: "center",
          }}
        >
          {otp.map((data, index) => {
            return (
              <input
                style={{
                  width: "15%",
                  marginRight: "6px",
                  marginLeft: "6px",
                  borderRadius: "6px",
                  textAlign: "center",
                  height: 100,
                  padding: "1px 2px",
                  height: "40px",
                  background: " #FFFFFF",
                  border: !err ? "1px solid #CED4DA" : "1px solid #f393a2",
                }}
                type="text"
                name="otp"
                key={index}
                value={data}
                onChange={(e) => handleChange(e.target, index)}
                onFocus={(e) => {
                  e.target.select();
                  currentInputIndex.current = index;
                }}
                ref={(ref) => (inputRefs.current[index] = ref)}
                size="small"
                maxLength="1"
                // inputProps={{ maxLength: 1 ,textalign:'center',mx:'auto'}}
              />
            );
          })}
        </Box>
        <FormGroup>
          <Button
            block
            color="success"
            size="sm"
            onClick={handleOTPVerification}
            // disabled={!(mobileState === "has-success" && passwordState === "has-success")}
          >
            Verify OTP
          </Button>
        </FormGroup>
        {displayResend ? (
          <Typography variant="button" fontWeight="regular">
            Haven&apos;t received it?{" "}
            <Typography
              component="a"
              href="#verification"
              variant="button"
              // onClick={handleResendOTP}
            >
              Resend OTP
            </Typography>
            .
          </Typography>
        ) : (
          <Typography variant="button" fontWeight="regular">
            {" "}
            Resend OTP in {seconds} seconds{" "}
          </Typography>
        )}
      
    </div>
  );
};

export default ResetOTP;
